import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthProvider";
import { TrashIcon } from "../../../constants/Icons";
const AccountDeletionTerms = () => {
  const navigate = useNavigate();
  const { isUser } = useAuth();
  const handleDeleteClick = () => {
    if (isUser) {
      navigate("/confirm-delete");
    } else {
      navigate("/deletion-login", { state: { from: "/delete-account" } });
    }
  };
  return (
    <div className=" d-flex justify-content-center "style={{ maxHeight: '100vh', overflowY: 'auto' }}>
      <div className="col-xxl-8 col-xl-9 col-lg-10 pt-3">
        <div className="text-center mb-6">
          <h4 className="fw-bold">Account Deletion – Terms and Conditions</h4>
        </div>

        <div className=" bg-white border p-4 border-2  rounded-3">
          <p>
            By submitting a request to delete your account, you acknowledge and
            agree to the following terms:
          </p>

          <h6 className="fw-bold mb-3">1. Cooling-Off Period</h6>
          <p>
            Upon submission of an account deletion request, your account will be
            temporarily deactivated for a period of 3 months.
          </p>
          <ul>
            <li>
              During this period, if you log in to your account, the deletion
              request will be automatically cancelled, and your account will be
              reinstated with full access.
            </li>
          </ul>

          <h6 className="fw-bold mb-3">2. Deletion Timeline</h6>
          <ul>
            <li>
              After the 3-month cooling-off period, we will initiate the
              permanent deletion process, which may take up to 6 months to
              complete.
            </li>
            <li>
              During this period, all data associated with your account will be
              progressively and securely removed from our systems.
            </li>
          </ul>

          <h6 className="fw-bold mb-3">3. Permanent Data Deletion</h6>
          <p>
            Once the deletion process is complete, the following data will be
            permanently and irreversibly deleted:
          </p>
          <ul>
            <li>All sales records</li>
            <li>Sub-account information</li>
            <li>Customer data</li>
            <li>
              Any other information or content associated with your account
            </li>
          </ul>

          <h6 className="fw-bold mb-3">4. No Recovery After Deletion</h6>
          <p>
            After the deletion is finalized, your data cannot be recovered under
            any circumstances. Please ensure that you have exported or backed up
            any necessary information before proceeding.
          </p>

          <h6 className="fw-bold mb-3">5. Compliance and Retention</h6>
          <p>
            In some cases, certain data may be retained for legal or regulatory
            compliance as per applicable laws. Such retention, if any, will be
            handled in accordance with our Privacy Policy.
          </p>

          <p>
            By proceeding with the deletion request, you confirm that you have
            read, understood, and agreed to these terms.
          </p>
        </div>
        <div className="d-flex justify-content-center p-3">
          <button
            type="button"
            className="btn btn-danger text-right"
            onClick={handleDeleteClick}
          >
            <TrashIcon iClass="font-20"/> Delete Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletionTerms;
